export default __webpack_public_path__ + "static/media/Shared-Image-ARTIGOS-SYS-05.b8f89030.png";